<template>
  <BaseButton
    id="modal-google-login"
    color="white"
    class="button--google w-full"
    @click="click"
  >
    {{ text }}
  </BaseButton>

  <div id="login-with-google-container" class="none" />
</template>
<script>
import '../../../../../es6/shared/google_login_manager.js.es6';
import '../../../../../es6/views/quick_estimate/google.js.es6';

import { csrfToken } from '@/utils';

import BaseButton from './BaseButton.vue';

export default {
  name: 'GoogleLoginButton',
  emits: ['click', 'success', 'error'],
  components: {
    BaseButton,
  },
  props: {
    text: {
      type: String,
      default: 'Login with Google',
    },
    apiConfig: {
      type: Object,
      required: true,
    },
    trackingParams: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      googleLoginApi: null,
    };
  },
  methods: {
    click() {
      this.$emit('click');

      this.googleLoginApi.triggerModal();
    },
  },
  mounted() {
    this.googleLoginApi = App.es6.views.quick_estimate.google({
      googleUrl: this.apiConfig.googleUrl,
      googleClientId: this.apiConfig.clientId,
      csrfToken: csrfToken(),
      buttonId: 'modal-google-login',
      trackingParams: this.trackingParams,
      callback: (response) => {
        this.$emit('success', response);
      },
    }).init(() => {
      if (!window._GAPI_ERROR) {
        return;
      }
      if (window._GAPI_ERROR === 'Cookies are not enabled in current environment.') {
        this.$emit('error', 'Please open the page in non-incognito mode to proceed');
        return;
      }
      this.$emit('error', 'Google Authentication is currently unavailable. Please try again later.');
      Rollbar.error('Google analytics initialize error: ', window._GAPI_ERROR);
    });
  },
};
</script>
